import React from "react";
import "../styles/Skills.css";
import { DiGo } from "react-icons/di";
import {
  FaChartLine,
  FaJsSquare,
  FaPython,
  FaReact,
  FaNodeJs,
  FaGitAlt,
  FaDocker,
  FaAws,
  FaDatabase,
} from "react-icons/fa";
import {
  SiScikitlearn,
  SiPytorch,
  SiTypescript,
  SiNextdotjs,
  SiMongodb,
  SiPostgresql,
  SiExpress,
  SiFastapi,
  SiRedis,
  SiTerraform,
  SiKubernetes,
} from "react-icons/si";

const Skills = () => {
  const skillsData = {
    appliedAi: {
      name: "Applied AI & Finance | Learning Focus",
      skills: [
        { name: "AWS SageMaker", icon: <FaAws /> },
        { name: "scikit-learn", icon: <SiScikitlearn /> },
        { name: "PyTorch", icon: <SiPytorch /> },
        { name: "Financial data analysis", icon: <FaChartLine /> },
      ],
    },
    languages: {
      name: "Languages",
      skills: [
        { name: "Python", icon: <FaPython /> },
        { name: "Golang", icon: <DiGo /> },
        { name: "JavaScript", icon: <FaJsSquare /> },
        { name: "TypeScript", icon: <SiTypescript /> },
      ],
    },
    frameworks: {
      name: "Frameworks/Libraries",
      skills: [
        { name: "React", icon: <FaReact /> },
        { name: "Nextjs", icon: <SiNextdotjs /> },
        { name: "Nodejs", icon: <FaNodeJs /> },
        { name: "Express", icon: <SiExpress /> },
        { name: "FastAPI", icon: <SiFastapi /> },
      ],
    },
    storages: {
      name: "Storages/Databases",
      skills: [
        { name: "MongoDB", icon: <SiMongodb /> },
        { name: "PostgreSQL", icon: <SiPostgresql /> },
        { name: "Redis", icon: <SiRedis /> },
        { name: "SQL", icon: <FaDatabase /> },
      ],
    },
    tooling: {
      name: "Tooling",
      skills: [
        { name: "Git", icon: <FaGitAlt /> },
        { name: "Docker", icon: <FaDocker /> },
        { name: "Kubernetes", icon: <SiKubernetes /> },
        { name: "AWS", icon: <FaAws /> },
        { name: "Terraform", icon: <SiTerraform /> },
      ],
    },
  };

  return (
    <section className="skills-section">
      <div className="skills-container">
        <h2 className="skills-title">Skills</h2>

        <div className="skills-list">
          {Object.entries(skillsData).map(([key, category]) => (
            <div key={key} className="skill-category">
              <h3 className="skill-category-name">{category.name}</h3>
              <div className="skill-items">
                {category.skills.map((skill, index) => (
                  <span key={index} className="skill-item">
                    <span className="skill-icon">{skill.icon}</span>
                    <span className="skill-name">{skill.name}</span>
                    {index < category.skills.length - 1 && (
                      <span className="skill-separator">,</span>
                    )}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
